import { format, parseISO } from 'date-fns';

export const STATUS_OPTIONS = [
  { value: 'planning', label: 'Planning' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'on_hold', label: 'On Hold' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const ACTIVE_STATUSES = ['planning', 'scheduled', 'in_progress', 'on_hold'];

export const TYPE_OPTIONS = [
  { value: 'rental_rehab', label: 'Rental Rehab' },
  { value: 'flip_renovation', label: 'Flip / Renovation' },
  { value: 'rental_turnover', label: 'Rental Turnover' },
  { value: 'residential_remodel', label: 'Residential Remodel' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'repair_maintenance', label: 'Repair / Maintenance' },
  { value: 'other', label: 'Other' },
];

export const SORT_OPTIONS = [
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'newest', label: 'Newest Created' },
  { value: 'oldest', label: 'Oldest Created' },
  { value: 'target_soonest', label: 'Target Date Soonest' },
  { value: 'name_az', label: 'Project Name A–Z' },
];

export const STATUS_STYLES = {
  planning: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  scheduled: 'bg-purple-500/15 text-purple-400 border-purple-500/30',
  in_progress: 'bg-[#D4AF37]/15 text-[#D4AF37] border-[#D4AF37]/30',
  on_hold: 'bg-orange-500/15 text-orange-400 border-orange-500/30',
  completed: 'bg-green-500/15 text-green-400 border-green-500/30',
  cancelled: 'bg-red-500/15 text-red-400 border-red-500/30',
};

export const statusLabel = (v) => (STATUS_OPTIONS.find((s) => s.value === v) || {}).label || v;
export const typeLabel = (v, custom) => {
  if (v === 'other' && custom) return custom;
  return (TYPE_OPTIONS.find((t) => t.value === v) || {}).label || v;
};

// ---- Money helpers (integer cents <-> dollars) ----
export const centsToDollarString = (cents) =>
  cents == null
    ? null
    : (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

export const centsToDollarInput = (cents) => (cents == null ? '' : String(cents / 100));

export const dollarsToCents = (val) => {
  if (val === '' || val == null) return null;
  const n = Number(String(val).replace(/[^0-9.]/g, ''));
  if (isNaN(n)) return null;
  return Math.round(n * 100);
};

// "N/A" acceptance for optional info the user doesn't have.
export const isNA = (v) => /^n\/?a\.?$/i.test(String(v ?? '').trim());
export const naToNull = (v) => {
  const t = String(v ?? '').trim();
  return !t || isNA(t) ? null : t;
};

// ---- Display helpers ----
export const fmtDate = (iso) => {
  if (!iso) return null;
  try {
    return format(parseISO(iso), 'MMM d, yyyy');
  } catch {
    return iso;
  }
};

export const formatLocation = (p) => {
  if (p.city && p.state) return `${p.city}, ${p.state}`;
  if (p.city) return p.city;
  if (p.state) return p.state;
  if (p.address_line1) return p.address_line1;
  return null;
};

export const fullAddress = (p) => {
  const parts = [];
  if (p.address_line1) parts.push(p.address_line1);
  if (p.address_line2) parts.push(p.address_line2);
  const cityStateZip = [p.city, p.state].filter(Boolean).join(', ');
  const line2 = [cityStateZip, p.zip_code].filter(Boolean).join(' ');
  if (line2.trim()) parts.push(line2.trim());
  return parts.length ? parts.join(', ') : null;
};

export const isOverdue = (p) => {
  if (!p.target_completion_date) return false;
  if (['completed', 'cancelled'].includes(p.status)) return false;
  if (p.is_archived) return false;
  try {
    return parseISO(p.target_completion_date) < new Date(new Date().toDateString());
  } catch {
    return false;
  }
};
